<script setup>
import {
    computed,
    defineProps,
    nextTick,
    onMounted,
    ref,
    watch,
    onUnmounted
} from 'vue';
import i18n from "@/i18n"
import { showMessage } from "@/utils/hooks/message"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import { getDashboardPerformance_comparison } from "@/service/apiList/dashboard"
import { getProductTemplatePt } from "@/service"
import { dashbordChart1 } from "@/utils/chart"
import { useRouter } from 'vue-router';
import PreviewImg from "@/components/common/PreviewImg";
import moment from 'moment';
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const activeImageSrc = ref('') //当前展示的二维码图片
const showPreviewImg = ref(false) //是否展示
const props = defineProps({
    databaseList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const router = useRouter()
// const chartRef = ref(null) // 图标dom
const tableInfo = ref([]) //表格数据
const hscodeList = ref([]) //hscode list
const dataPublicList = ref([])
const type = ref("") // 模板类型
const table_head = ref([
    { name: 'NO.', width: '2%', type: 'index' },
    { name: getLangValue("product-template.productName"), width: '10%', type: 'name', sortable: true, sortField: 'name' },
    { name: getLangValue('product-management', "code_pid_gtin"), width: '10%', type: 'pid' },
    { name: getLangValue("product-template.publicType",), type: 'public_type', width: '10%' },
    { name: getLangValue("product-template.price"), type: 'price', width: '10%', },
    { name: getLangValue("product-template.size"), type: 'size', width: '10%', },
    { name: getLangValue("product-template.color"), type: 'color', width: '10%', },
    { name: getLangValue("product-template.origin"), type: 'origin', width: '10%', },
    { name: getLangValue("attribute.supplier"), type: 'supplier', width: '10%', },
    { name: getLangValue("dashboard.listingTime"), width: '10%', type: 'release_time' },
])
const colors = ['#F06548', '#405189', '#0AB39C', 'green', 'pink']
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false) //加载
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getDataList)
const hscode = ref('') //hscode
const keyword = ref('') //关键字
const dataPublicType = ref('') // 数据公开类型
const selectedTableData = ref([]) //选中的数据
const lastId = ref('') //最后选择的id
// const index_standard_group = ref([]) //指标组数据
const searchInfo = ref({}) //排序信息  先保留
const templateStr = ref(computed(() => JSON.stringify(props.databaseList))) //监听
let resizemychart1Ob = null // mychart 振动 动态监听
const getDataList = async () => {
    loading.value = true
    // selectedTableData.value = []
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        hscode_id: hscode.value,
        keyword: keyword.value.trim().replace('FBD', ''),
        category_id: 1, //可追溯性
        product_template_name: type.value,
        order_by: searchInfo.value.type,
        sort_field: searchInfo.value.name,
        public_type: dataPublicType.value,
    }
    // 产品性能
    const resp = await getDashboardPerformance_comparison(params);
    loading.value = false
    if (resp.code == 0) {
        if (resp.payload.length == 0 || resp.payload.data.length == 0) {
            showMessage('info', getLangValue('base.no_data'))
        }
        tableInfo.value = resp.payload.data;
        tableInfo.value.forEach(async element => {
            // 设置二维码
            if (element.pid) {
                const reps = await makeQrCode({ type: 2, id: element.id })
                if (reps) {
                    element.qrcodeImgUrl = reps
                }
            }
        });
        total.value = resp.payload.total
        setPages();
        if (tableInfo.value.length && currentPage.value == 1 && selectedTableData.value.length == 0) {
            tableInfo.value[0].checked = true; //默认选中一个
            changCheckBox(tableInfo.value[0].id)
        }
        // 如果已经选择了数据 需要回显
        if (selectedTableData.value.length) {
            for (const item in selectedTableData.value) {
                // 如果由当前数据 就需要选中
                const obj = tableInfo.value.find(table => table.id == selectedTableData.value[item].id)
                if (obj) {
                    obj.checked = true;
                }
            }
        }
    }
}

const sort = (name) => {
    searchInfo.value.name = name
    searchInfo.value.type = searchInfo.value.type == 'asc' ? 'desc' : 'asc'
    getDataList()
}

const search = () => {
    //搜索
    // emits('search', { hscode: hscode.value, keyword: keyword.value, })
    if (!hscode.value) {
        showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
        return;
    }
    currentPage.value = 1;
    selectedTableData.value = []; //置空
    getDataList();
}

const setPages = () => {
    pageOption.value = [];
    let numberOfPages = Math.ceil(total.value / pageSize.value);
    for (let index = 1; index <= numberOfPages; index++) {
        pageOption.value.push(index);
    }
}

const setCharts = () => {
    // 图表绘制
    // console.log(selectedTableData.value);
    let xAxisData = selectedTableData.value[0].index_standard_statistics.map(item => i18n.global.locale == 'en' ? item.group_name_en : item.group_name)
    let option = {
        legend: { show: false },
        color: colors,
        // tooltip: { trigger: 'axis' },
        tooltip: {
            trigger: 'axis', formatter: function (params) {
                let res = params[0].name + '<br/>'
                console.log(params);
                params.forEach(item => {
                    res += item.value ? `NO.${item.data.no + 1} ` + item.seriesName + ': ' + item.value + '<br/>' : `NO.${item.data.no + 1} ` + item.seriesName + ': 0<br/>';
                })
                return res
            }
        },
        xAxis: { type: 'category', data: xAxisData },
        yAxis: {},
        grid: {
            top: '3%',
            left: '3%',
            right: '4%',
            bottom: '20%',
            containLabel: true
        },
        series: selectedTableData.value.map((item, index) => {
            let data = []
            for (const item1 in item.index_standard_statistics) {
                data.push({ value: item.index_standard_statistics[item1].value, no: index });
            }
            return {
                name: item.pid,
                type: 'bar',
                data: data,
                barWidth: 20,
                color: colors[index]
            }
        })
    };
    // if (xAxisData.length > 5) {
    //     option.dataZoom = [{
    //         type: 'slider',
    //         realtime: true,
    //         start: 0,
    //         end: 40,  // 初始展示40%
    //         height: 4,
    //         fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
    //         borderColor: "rgba(17, 100, 210, 0.12)",
    //         handleSize: 0, // 两边手柄尺寸
    //         showDetail: false, // 拖拽时是否展示滚动条两侧的文字
    //         bottom: 55,
    //         // zoomLock:true, // 是否只平移不缩放
    //         // moveOnMouseMove:true, //鼠标移动能触发数据窗口平移
    //         // zoomOnMouseWheel :true, //鼠标移动能触发数据窗口缩放
    //     },
    //     {
    //         type: "inside",  // 支持内部鼠标滚动平移
    //         start: 0,
    //         end: 40,
    //         zoomOnMouseWheel: false,  // 关闭滚轮缩放
    //         moveOnMouseWheel: true, // 开启滚轮平移
    //         moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
    //     }]
    // }
    nextTick(() => {
        let dom = document.getElementById('chartRef')
        const mychartRarda = dashbordChart1(dom, option)
        // 监听容器宽度变化
        resizemychart1Ob = new ResizeObserver(() => mychartRarda.resize());
        resizemychart1Ob.observe(dom);
    })

}

const changCheckBox = (id) => {
    lastId.value = id
    // 复选框状态改变
    // let arr = []
    // tableInfo.value.forEach((item, index) => {
    //     if (item.checked) {
    //         item.no = index
    //         arr.push(item) 
    //     }
    // })
    const item = tableInfo.value.find(item => item.id == id)
    if (item.checked) {
        selectedTableData.value.push(item);
    } else {
        const index = selectedTableData.value.findIndex(item => item.id == id)
        if (index > -1) {
            selectedTableData.value.splice(index, 1)
        }
    }
    if (selectedTableData.value.length <= 5) {
        if (selectedTableData.value.length)
            setCharts();
    } else {
        //去掉最后一个id
        tableInfo.value.forEach(item => {
            if (item.id == id)
                item.checked = false
        })
        //去掉
        const index = selectedTableData.value.findIndex(item => item.id == id)
        if (index > -1) {
            selectedTableData.value.splice(index, 1)
        }
        showMessage('info', getLangValue('dashboard.selectedLength'))
        return
    }

}

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const remove = (key) => {
    // 图表移除pid
    let id = selectedTableData.value[key].id
    selectedTableData.value.splice(key, 1)
    tableInfo.value.forEach(item => {
        if (item.id == id)
            item.checked = false
    })
    changCheckBox(id)
}
const getDataPublicType = async () => {
    // 获取公共数据类型
    const res = await getProductTemplatePt()
    if (res.code == 0) {
        dataPublicList.value = res.payload;
    }
}

const changeTemplate = async () => {
    // 切换模板
    hscode.value = ''
    if (type.value.length) {
        console.log(type.value);
        let arr = props.databaseList.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}

const router2Passport = ({ id }) => {
    // 跳转到passport
    console.log(id);
    const url = router.resolve({ path: '/dashboard-traceability-digital-passport', query: { id: id || '672c852c5f3422276241e854' } }).href
    window.open(url, '_blank')
}

const getPublic = (type) => {
    let arr = dataPublicList.value.filter(item => item.id === type)
    if (arr.length) {
        return arr[0].name
    }
    return ''
}

onMounted(() => {
    getDataPublicType();
    // type.value = props.databaseList[0].value;
    // hscode.value = props.databaseList[0].children[0].value;
})
// 销毁
onUnmounted(() => {
    if (resizemychart1Ob) {
        console.log('销毁振动..');
        resizemychart1Ob.disconnect();
    }
})

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
})

watch(currentPage, () => {
    getDataList();
})

watch(templateStr, async (val) => {
    //监听传过来的数据
    let arr = JSON.parse(val)
    type.value = [arr[0].value, arr[0].children[0].value] // 选择第一个
    await changeTemplate() // 切换shcode
    // 选择第一个列表
    hscode.value = hscodeList.value[0].id;
    // 查询数据
    search();
})

watch(selectedTableData, (val) => {
    if (val.length) {
        document.getElementById('my-table').style.height = 'calc(100% - 350px)'
    } else {
        document.getElementById('my-table').style.height = '100%'
    }
}, { deep: true })


</script>
<template>
    <div class="qualityTable px-3 py-2 " style="height: calc(100% - 1rem) ">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <el-cascader style="min-width: 300px; height: 38px;" v-model="type" :options="props.databaseList"
                    :placeholder="getLangValue('dashboard.dataBaseType')"
                    :props="{ label: i18n.global.locale == 'en' ? 'label_en' : 'label', }" @change="changeTemplate" />
                <el-select v-model="hscode" filterable clearable class="mx-2" placeholder="HS Code"
                    style="width: 204px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value"
                        :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                </el-select>
                <div class="form-icon">
                    <input style="width: 236px;" clearable class="form-control form-control-icon" v-model="keyword"
                        required :placeholder="getLangValue('dashboard.input1')" />
                    <i class="ri-search-line"></i>
                </div>
                <el-select v-model="dataPublicType" filterable clearable class="mx-2"
                    :placeholder="getLangValue('dashboard.traceability.placeholder1')"
                    style="width: 204px; height: 38px;">
                    <el-option v-for="(item, key) in dataPublicList" :key="key" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <button type="button" class="btn btn-success" @click="search()" style="min-width: 93px;">
                {{ getLangValue("base.search") }}
            </button>
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);" v-loading="loading">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar">
                    <table class="table  table-nowrap">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" v-for="(head, index) in table_head" :key="index"
                                    style="color: #2E404C; align-items: center;" :width="head.width">
                                    <div class="d-flex align-items-center"
                                        :style="head.sortable ?
                                            { height: '36px', 'max-width': '120px', 'word-break': 'keep-all', 'white-space': 'normal' } : { height: '36px' }">
                                        {{ head.name }}
                                        <div class="sortable mx-2 cursor-pointer" :class="searchInfo.name == head.sortField && searchInfo.type == 'desc' ? 'sortdesc' :
                                            searchInfo.name == head.sortField && searchInfo.type == 'asc' ? 'sortasc' : ''"
                                            v-if="head.sortable" style="position: relative; width: 14px; height: 10px;"
                                            @click="sort(head.sortField)">
                                        </div>
                                    </div>
                                </th>
                                <th width="10%" style="color: #2E404C;">{{ getLangValue("base.operation") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="cursor-pointer" @click.stop="router2Passport(info)"
                                v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                                <template v-for="(head, kk) in table_head" :key="kk">
                                    <td v-if="head.type == 'index'"> {{ index + 1 }}</td>
                                    <td v-else-if="head.type == 'pid'">
                                        <img @click.stop="showImageCode(info.qrcodeImgUrl)" class="cursor-pointer"
                                            :title="`FBD` + info.pid" :src="info['qrcodeImgUrl']"
                                            style="width: 48px;height: 48px;" />
                                    </td>
                                    <td v-else-if="head.type == 'origin'">
                                        {{ info.production_line?.place_of_origin?.name }}
                                    </td>
                                    <td v-else-if="head.type == 'supplier'">
                                        {{ info.organization && info.organization.company_name }}
                                    </td>
                                    <td v-else-if="head.type == 'release_time'">
                                        {{ info.release_time ? moment(info.release_time).format('YYYY-MM-DD HH:mm:ss') :
                                            '' }}
                                    </td>
                                    <td v-else-if="head.type == 'public_type'">
                                        <span v-if="info.public_type">
                                            {{ info.public_type ?
                                                getPublic(info.public_type) : '' }}</span>
                                    </td>
                                    <td v-else-if="head.type == 'name'"
                                        style="width: 300px; word-break: keep-all;word-wrap: break-word; white-space: normal;">
                                        <span v-if="info.name">{{ info.name }}</span>
                                    </td>
                                    <td v-else>
                                        {{ info[head.type] }}
                                    </td>
                                </template>
                                <td @click.stop="() => { }">
                                    <input @change="changCheckBox(info.id)" class="form-check-input mt-0"
                                        type="checkbox" v-model="info.checked"
                                        aria-label="Checkbox for following text input">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
            <div class="charts" v-if="selectedTableData.length" style="position: relative; width: 100%; ">
                <div style="width: 100%; height: 100%;" ref="chartRef" id="chartRef"></div>
                <div style="position: absolute; bottom: -15px;width: 100%; flex-wrap: wrap; min-height: 60px;"
                    class="d-flex justify-content-center">
                    <div class="mx-3 d-flex align-items-center" v-for="(item, key) in selectedTableData" :key="key"
                        style="color: #878A99;font-size: 14px;">
                        <div style="width: 14px; height: 14px;" :style="{ backgroundColor: colors[key] }"></div>
                        <span class="mx-2">No.{{ key + 1 }} {{ item.pid }}</span>
                        <i class="ri-delete-bin-line cursor-pointer" style="color: #ED5E5E;" @click="remove(key)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
</template>
<style scoped lang="scss">
.qualityTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            // color: white;
        }

        :deep(.el-input__wrapper) {
            // background-color: #4a5056;
        }

        :deep(.el-input__inner) {
            // color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                // color: white
            }
        }

        .form-control {
            // background-color: #4a5056;
            // color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #212529;
        }

        .my-pagination {
            color: #212529;

            :deep(.page_total) {
                color: #212529 !important;
            }
        }
    }

    .charts {
        height: 350px;
    }

    .sortActive {
        i {
            color: black !important;
        }

    }

    .sortable {
        &::after {
            content: "\f035d";
            position: absolute;
            right: .5rem;
            top: 0px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }

        &::before {
            content: "\f0360";
            position: absolute;
            right: .5rem;
            top: -8px;
            font-size: .8rem;
            font-family: "Material Design Icons";
            color: #bcbdbe;
        }
    }

    .sortdesc {
        &::after {
            color: black;
        }
    }

    .sortasc {
        &::before {
            color: black;
        }
    }
}
</style>